import type { Metric } from '../types';

export type WinsorizationFields = Partial<Pick<Metric, 'winsorLowerPercentile' | 'winsorUpperPercentile'>>;

/** True when at least one winsorization bound is configured. */
export function hasWinsorization({ winsorLowerPercentile, winsorUpperPercentile }: WinsorizationFields): boolean {
  return winsorLowerPercentile !== undefined || winsorUpperPercentile !== undefined;
}

export function MetricWinsorization({ metric }: { metric: WinsorizationFields }) {
  const { winsorLowerPercentile, winsorUpperPercentile } = metric;

  const bounds = [];
  if (winsorLowerPercentile !== undefined) {
    bounds.push(`Lower ${winsorLowerPercentile}%`);
  }
  if (winsorUpperPercentile !== undefined) {
    bounds.push(`Upper ${winsorUpperPercentile}%`);
  }

  if (bounds.length === 0) {
    return null;
  }

  return <span>{bounds.join(', ')}</span>;
}
